var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReversedKanban = function SvgReversedKanban(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    x: -0.5,
    y: 0.5,
    stroke: "inherit",
    rx: 0.5,
    transform: "matrix(-1 0 0 1 14 2.679)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 10,
    x: -0.5,
    y: 0.5,
    stroke: "inherit",
    rx: 0.5,
    transform: "matrix(-1 0 0 1 6.5 2.679)"
  })));
};
export default SvgReversedKanban;